import {FBFieldBaseOptions, FieldTypeEnum} from "FormBuilder/Fields/Core/FBFieldBase.options";


export class FBDividerOptions extends FBFieldBaseOptions{
    public Style:string;
    public Color:string;
    public Title:string;

    protected LoadDefaultValues() {
        super.LoadDefaultValues();
        this.Title='';
        this.Type=FieldTypeEnum.Divider;
        this.Style='solid';
        this.Color='#dfdfdf';
    }


}

